import { en_US } from "ng-zorro-antd/i18n";
import { UiI18nInterface } from "../i18n.models";

const locale = en_US as unknown as UiI18nInterface;

locale.DatePicker.lang.shortDate = "MM/dd/yyyy";
locale.DatePicker.lang.longDate = "MMMM dd, yyyy";
locale.DatePicker.lang.previousYear = "previous year";
locale.DatePicker.lang.nextYear = "next year";
locale.DatePicker.lang.previousMonth = "previous month";
locale.DatePicker.lang.nextMonth = "next month";
locale.DatePicker.lang.fromDate = "from";
locale.DatePicker.lang.toDate = "to";
locale.DatePicker.lang.tomorrow = "tomorrow";
locale.DatePicker.lang.today = "today";
locale.DatePicker.lang.yesterday = "yesterday";
locale.DatePicker.lang.dateSelect = "Choose Date";
locale.DatePicker.lang.decadeSelect = "Choose decade";
locale.DatePicker.lang.monthSelect = "Choose month";
locale.DatePicker.lang.timeSelect = "Choose time";
locale.DatePicker.lang.weekSelect = "Choose week";
locale.DatePicker.lang.yearSelect = "Choose year";

locale.Assignee = {
  deactivated: "deactivated",
  deletedTeam: "deleted team",
  deletedUser: "deleted user",
};

locale.Modal.cancelText = "Cancel";
locale.Modal.closeText = "Close";

locale.LoadingIndicator = {
  loading: "Loading...",
};

locale.Select = {
  noSearchResultsFound: "No search results found.",
  noValueSelected: "No value selected.",
  selectedItem: "selected item : %item%",
  selectedItems: "%itemsCount% selected items : %items%",
};

locale.Toast = {
  dismiss: "Dismiss message",
  info: "Informational message",
  success: "Success message",
  warning: "Warning message",
  error: "Error message",
  loading: "Loading message",
};

locale.Validation = {
  error: "Error",
  info: "Informative",
  success: "Success",
  warning: "Warning",
};

locale.Button = {
  openDropdown: "Open",
};

locale.Pagination.prev_page = "Previous";
locale.Pagination.next_page = "Next";
locale.Pagination.current = "Current page";
locale.Pagination.title = "Pagination navigation";

export { locale };
